import { Box, Button, Dialog, Stack, Typography } from "@mui/material";

import { theme } from "../../../../../assets";

export const ProfileActivityErrorDialog = ({
    handleClose,
    open,
}: {
    handleClose: () => void;
    open: boolean;
}) => {
    return (
        <Dialog
            open={open}
            sx={{
                ".MuiDialog-paper": {
                    width: "100%",
                    maxWidth: "36.6875rem",
                    overflowY: "unset",
                },
            }}
        >
            <Stack
                sx={{
                    p: "1rem",
                    width: "100%",
                    gap: "0.875rem",
                }}
            >
                <Stack
                    sx={{
                        gap: "0.75rem",
                        px: "1.5rem ",
                        marginTop: "1vh",
                    }}
                >
                    <Typography variant="h6">Perfil Incompleto</Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: theme.gray500,
                        }}
                    >
                        Um ou mais colaboradores estão sem perfil de atividade
                        atribuídos a eles.
                        <br />
                        <br />
                        Para continuar adicione um perfil de atividade aos novos
                        colaboradores.
                    </Typography>
                </Stack>

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "1rem",
                    }}
                >
                    <Button variant="text" onClick={handleClose}>
                        voltar
                    </Button>
                </Box>
            </Stack>
        </Dialog>
    );
};
